import { Box, Stack, ListItemText, ListItemAvatar, ListItemButton } from '@mui/material';
import { useRouter } from 'src/routes/hooks';
import { NotificationCategory } from 'src/type/notification';
import { fToNow } from 'src/utils/format-time';

type Props = {
  title: string;
  category?: NotificationCategory;
  createdAt: string;
  isRead: boolean;
  link?: string;
  onRead?: () => void;
};

export default function NotificationItem({
  title,
  category,
  createdAt,
  isRead,
  link,
  onRead,
}: Props) {
  const router = useRouter();

  const renderUnReadBadge = !isRead && (
    <Box
      sx={{
        top: 16,
        width: 12,
        height: 12,
        right: 20,
        borderRadius: '50%',
        bgcolor: 'warning.main',
        position: 'absolute',
      }}
    />
  );

  const renderAvatar = (
    <ListItemAvatar>
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          bgcolor: 'background.neutral',
        }}
      >
        <Box
          component="img"
          src="/assets/icons/common/ic-default-notification.svg"
          sx={{ width: 24, height: 24 }}
        />
      </Stack>
    </ListItemAvatar>
  );

  const handleClick = () => {
    if (onRead) {
      onRead();
    }
    router.push(link || '#');
  };

  return (
    // <Link
    //   component="button"
    //   onClick={onRead}
    //   href={link || '#'}
    //   underline="none"
    //   color="text.primary"
    // >
    <Box onClick={handleClick} color="text.primary">
      <ListItemButton
        disableRipple
        sx={{
          p: 2.5,
          alignItems: 'flex-start',
          border: (theme) => `dashed 1px ${theme.palette.divider}`,
        }}
      >
        {renderUnReadBadge}

        {renderAvatar}

        <Stack sx={{ flexGrow: 1 }}>
          <ListItemText
            disableTypography
            primary={title}
            secondary={
              <Stack
                direction="row"
                alignItems="center"
                sx={{ typography: 'caption', color: 'text.disabled' }}
                divider={
                  <Box
                    sx={{
                      width: 2,
                      height: 2,
                      bgcolor: 'currentColor',
                      mx: 0.5,
                      borderRadius: '50%',
                    }}
                  />
                }
              >
                {fToNow(createdAt)}
                {category === NotificationCategory.BUY && 'ซื้อ'}
                {category === NotificationCategory.SELL && 'ขาย'}
                {category === NotificationCategory.TOPUP_CREDIT && 'เติมเงิน'}
                {category === NotificationCategory.WITHDRAW_CREDIT && 'ถอนเงิน'}
                {category === NotificationCategory.REDEEM && 'แลกทอง'}
                {category === NotificationCategory.CREDIT_LOAN && 'ยืมเครดิต'}
                {category === NotificationCategory.PAY_CREDIT_LOAN && 'ชำระเครดิต'}
              </Stack>
            }
          />
        </Stack>
      </ListItemButton>
    </Box>
    // </Link>
  );
}
